<app-flight-report-details
    [visible]="true"
    mode="create"
    [assessmentId]="assessmentId"
    [issueId]="issueId"
    [parentReportId]="parentReportId"
    [promotionId]="promotionId"
    [returnTo]="returnTo"
    (closed)="onClose()">
</app-flight-report-details>
